export function arrayToObject(items, keyName) {
    if (!items)
        return {}
    return items.reduce(
        (obj, item) => {
            const key = item[keyName]
            obj[key] = item
            return obj
        }, {}
    )
}

export function objectToArray(obj, transform) {
    const objItems = []
    for(const key in obj) {
        const value = obj[key]
        objItems.push(transform ? transform(value) : value)
    }
    return objItems
}

export function transformObject(obj, transform) {
    return Object.keys(obj).reduce((result, i) => {
        result[i] = transform(obj[i])
        return result
    }, {})
}


// WEBPACK FOOTER //
// ./src/helper.jsx